<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end form-offcanvas"
    tabindex="-1"
    id="offcanvas"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="offcanvas-header border-bottom bg-white py-3">
      <h6 class="offcanvas-title fw-bold mb-0 d-flex align-items-center gap-2">
        <i class="fa-solid fa-warehouse text-theme" />
        {{ type === 'CREATE'? $t('Create Inventory'): $t('Edit Inventory')  }}
      </h6>
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body bg-body-secondary p-3"
      v-else
    >
      <div class="form-card">
        <div class="form-section-header">
          <i class="fa-solid fa-circle-info" />
          <span>{{ $t('Inventory Information') }}</span>
        </div>
        <div class="px-3 pt-3">
          <div class="row g-3 py-2">
          <div class="col-md-4">
            <label
              for="name"
              class="form-label"
            >
              {{ $t('Name') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm">
              <input
                id="name"
                type="text"
                v-model.trim="v$.form.name.$model"
                class="form-control"
                :placeholder="$t('Enter inventory name') + '...'"
              >
              <div v-for="error of v$.form.name.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.name === form.name">
                <div v-for="error of errors.name"
                  class="d-block invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-4">
            <label
              for="code"
              class="form-label"
            >
              {{ $t('Code') }}
            </label>
            <div class="input-group-sm ">
              <input
                id="code"
                type="text"
                v-model.trim="v$.form.code.$model"
                class="form-control"
                :placeholder="$t('Enter inventory code') + '...'"
                :disabled="type === 'EDIT'"
              >
              <div v-for="error of v$.form.code.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.code === form.code">
                <div v-for="error of errors.code"
                  class="d-block invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-4">
            <label for="Category" class="form-label">
              {{ $t('Category') }}
              <span class="text-danger">*</span>
            </label>
            <select2
              v-model.trim="v$.form.inventory_category_id.$model"
              :options="select2FormCategory.options"
              :settings="select2FormCategory.setting"
            />
          </div>
          <div class="col-md-4">
            <label for="Storage" class="form-label">
              {{ $t('Storage') }}
              <span class="text-danger">*</span>
            </label>
            <select2
              v-model.trim="v$.form.storage_condition.$model"
              :options="select2FormStorage.options"
              :settings="select2FormStorage.setting"
            />
          </div>
          <div class="col-md-4">
            <label for="Storage" class="form-label">
              {{ $t('Type') }}
              <span class="text-danger">*</span>
            </label>
            <select2
              v-model.trim="v$.form.type.$model"
              :options="select2FormType.options"
              :settings="select2FormType.setting"
            />
          </div>
          <div class="col-md-4">
            <label for="Tax" class="form-label">
              {{ $t('Tax Status') }}
              <span class="text-danger">*</span>
            </label>
            <select2
              v-model.trim="v$.form.tax_status.$model"
              :options="select2FormTaxStatus.options"
              :settings="select2FormTaxStatus.setting"
              :disabled="isVariant"
            />
          </div>
          <div class="col-md-4">
            <label
              for="cost_manual"
              class="form-label"
            >
              {{ $t('Manual Cost') }}
            </label>
            <div class="input-group input-group-sm">
              <input
                id="cost_manual"
                type="number"
                inputmode="decimal"
                v-model.trim="v$.form.cost_manual.$model"
                class="form-control"
                :class="v$.form.cost_manual.$error? 'is-invalid': ''"
                :placeholder="form.cost ? formatDigit(form.cost) : ($t('Enter manual cost') + '...')"
              >
              <span class="input-group-text">
                {{ $t('฿') }}
              </span>
              <div v-for="error of v$.form.cost_manual.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.cost_manual === form.cost_manual">
                <div v-for="error of errors.cost_manual"
                  class="d-block invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
            <small class="form-text text-muted">
              {{ $t('Leave blank to use MAC (Moving Average Cost) automatically.') }}
            </small>
          </div>
          <div class="col-md-12">
            <label for="images" class="form-label">{{ $t('Media') }}</label>
            <vue-upload-multiple-image
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
              @edit-image="editImage"
              @limit-exceeded="limitExceeded"
              :max-image="image.maxImage"
              :data-images="images"
              :show-primary="image.showPrimary"
              :show-edit="image.showEdit"
              id-upload="myIdUpload"
              edit-upload="myIdEdit"
              :drag-text="$t('Drage Image')"
              :browse-text="$t('Browse Image')"
              primary-text="Base image"
              mark-is-primary-text="Set base image"
              popup-text="default base image"
              :drop-text="$t('Drag and drop')"
              :multiple="false"
            />
            <span class="form-text text-muted">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50">
                <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"></path>
              </svg>
              {{ this.maxUploadImg }}
            </span>
            <template v-if="oldParams.image === form.image">
              <div v-for="error of errors.image"
                class="d-block invalid-feedback"
              >
                {{ $t(error) }}
              </div>
            </template>
          </div>
        </div>
      </div>
      </div>

      <div class="form-card">
        <div class="form-section-header">
          <i class="fa-solid fa-scale-balanced" />
          <span>{{ $t('Unit Conversions') }}</span>
        </div>
        <div class="px-3 pt-3">
        <div class="row g-3 py-2">
          <div class="col-md-4">
            <label for="Unit" class="form-label">
              {{ $t('Base Unit') }}
              <span class="text-danger">*</span>
            </label>
            <select2
              v-model.trim="v$.form.unit_id.$model"
              @select="onSelectUnit"
              :options="select2FormUnit.options"
              :settings="select2FormUnit.setting"
            />
            <small v-if="type === 'EDIT'" class="form-text text-muted">
              {{ $t('Changing the base unit does not auto-convert existing stock & cost.') }}
            </small>
          </div>
          <div class="col-md-12" v-if="form.unit_conversions.length > 0">
            <div class="border rounded">
              <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="(unitConversion, index) in form.unit_conversions" :key="index">
                  <unit-conversion-form :unit-conversion="unitConversion" :index="index" />
                </li>
              </ul>
            </div>
          </div>
          <div class="d-flex">
            <button
              @click="addUnit()"
              type="button"
              class="btn btn-theme btn-sm"
            >
              <i class="fa-solid fa-circle-plus me-1" />
              {{ $t('Add') }}
            </button>
          </div>
        </div>
        </div>
      </div>

      <div v-if="type === 'CREATE'" class="form-card">
        <div class="form-section-header">
          <i class="fa-solid fa-boxes-stacked" />
          <span>{{ $t('Initial Stock') }}</span>
        </div>
        <div class="px-3 pt-3">
        <div class="form-check">
          <input v-model="form.initial_stock_add" class="form-check-input" type="checkbox" id="defaultCheck1">
          <label class="form-check-label" for="defaultCheck1">
          {{ $t('Add Initial Stock') }}
          </label>
        </div>
        <div v-if="form.initial_stock_add" class="row g-3 py-2">
          <div class="col-md-4">
            <label
              for="wherehouse"
              class="form-label"
            >
              {{ $t('Wherehouse/Branch') }}
              <span class="text-danger">*</span>
            </label>
            <select2
              v-model.trim="v$.form.initial_stock_branch_id.$model"
              @select="onSelectUnit"
              :options="select2FormBranch.options"
              :settings="select2FormBranch.setting"
            />
          </div>
          <div class="col-8 col-md-3">
            <label
              for="quantity"
              class="form-label"
            >
              {{ $t('Quantity') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm ">
              <input
                id="quantity"
                type="number"
                inputmode="decimal"
                v-model.trim="v$.form.initial_stock_quantity.$model"
                class="form-control"
                :placeholder="$t('Enter quantity') + '...'"
              >
              <div v-for="error of v$.form.initial_stock_quantity.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.initial_stock_quantity === form.initial_stock_quantity">
                <div v-for="error of errors.initial_stock_quantity"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-4 col-md-2">
            <label
              for="quantity"
              class="form-label"
            >
              {{ $t('Unit') }}
            </label>
            <div class="input-group-sm ">
              <input
                class="form-control"
                :value="unitName"
                disabled
              >
            </div>
          </div>
          <div class="col-md-3">
            <label
              for="cost"
              class="form-label"
            >
              {{ $t('Cost per Unit') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm ">
              <input
                id="cost"
                type="number"
                inputmode="decimal"
                v-model.trim="v$.form.initial_stock_cost.$model"
                class="form-control"
                :placeholder="$t('Enter cost per unit') + '...'"
                @change="() => {
                  form.cost = form.initial_stock_cost;
                }"
              >
              <div v-for="error of v$.form.initial_stock_cost.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.initial_stock_cost === form.initial_stock_cost">
                <div v-for="error of errors.initial_stock_cost"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-3">
            <label
              for="received_date"
              class="form-label"
            >
              {{ $t('Received Date') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm ">
              <input
                id="received_date"
                type="date"
                v-model.trim="v$.form.initial_stock_received_date.$model"
                class="form-control"
                :placeholder="$t('Enter received date') + '...'"
                @change="() => {
                  if (form.initial_stock_expiry_date && form.initial_stock_received_date >= form.initial_stock_expiry_date) {
                    form.initial_stock_expiry_date = null;
                  }
                }"
              >
              <div v-for="error of v$.form.initial_stock_received_date.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.initial_stock_received_date === form.initial_stock_received_date">
                <div v-for="error of errors.initial_stock_received_date"
                  class="d-block invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-3">
            <label
              for="expiry_date'"
              class="form-label"
            >
              {{ $t('Expiry Date') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm ">
              <input
                id="expiry_date'"
                type="date"
                v-model.trim="v$.form.initial_stock_expiry_date.$model"
                class="form-control"
                :placeholder="$t('Enter expiry date') + '...'"
              >
              <div v-for="error of v$.form.initial_stock_expiry_date.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.initial_stock_expiry_date === form.initial_stock_expiry_date">
                <div v-for="error of errors.initial_stock_expiry_date"
                  class="d-block invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <ladda
        text="Save"
        v-if="type === 'CREATE'"
        :btn-class="'btn btn-theme btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleCreate"
      />
      <ladda
        text="Save"
        v-if="type === 'EDIT'"
        :btn-class="'btn btn-theme btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleUpdate"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import Select2 from 'vue3-select2-component';
import { Inventories } from '@/services/endpoint/inventories.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import Ladda from '@/plugins/Ladda.vue';
import numeral from 'numeral';
import VueUploadMultipleImage from '@/plugins/VueUploadMultipleImage.vue';
import moment from "moment";
import UnitConversionForm from './UnitConversionForm.vue';
import _ from 'lodash';
import { apiErrorText } from '@/utils/apiError';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.form);
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    inventoryId: {
      type: Number,
      default: 0
    }
  },
  data() {
    let vm = this;
    return {
      loading: true,
      loadingSave: false,
      hasPermission: false,
      image: {
        maxImage: 1,
        maxSize: 5,
        showPrimary: false,
        showEdit: false
      },
      images: [],
      form: {
        name: '',
        code: '',
        quantity: 0.0000,
        cost: 0.0000,
        cost_manual: '',
        storage_condition: 'ambient',
        type: 'ingredient',
        unit_id: '1',
        unit_conversions: [],
        inventory_category_id: '1',
        tax_status: 'vatable',
        image: '',
        initial_stock_add: false,
        initial_stock_branch_id: 1,
        initial_stock_quantity: '',
        initial_stock_cost: '',
        initial_stock_received_date: moment(Date.now()).format('YYYY-MM-DD'),
        initial_stock_expiry_date: moment(Date.now()).format('YYYY-MM-DD')
      },
      errors: {
        name: [],
        code: [],
        quantity: [],
        cost: [],
        cost_manual: [],
        storage_condition: [],
        type: [],
        unit_id: [],
        unit_conversions: [],
        inventory_category_id: [],
        tax_status: [],
        image: [],
        initial_stock_add: [],
        initial_stock_branch_id: [],
        initial_stock_quantity: [],
        initial_stock_cost: [],
        initial_stock_received_date: [],
        initial_stock_expiry_date: []
      },
      oldParams: {
        name: '',
        code: '',
        quantity: 0.0000,
        cost: 0.0000,
        cost_manual: '',
        storage_condition: '',
        type: '',
        unit_id: '',
        unit_conversions: [],
        inventory_category_id: '',
        image: '',
        initial_stock_add: false,
        initial_stock_branch_id: 1,
        initial_stock_quantity: '',
        initial_stock_cost: '',
        initial_stock_received_date: moment(Date.now()).format('YYYY-MM-DD'),
        initial_stock_expiry_date: moment(Date.now()).format('YYYY-MM-DD')
      },
      select2FormBranch: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2FormUnit: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2FormUnitConversion: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        },
        allOptions: []
      },
      select2FormCategory: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2FormStorage: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2FormType: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2FormTaxStatus: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
    }
  },
  components: {
    Select2,
    PlaceholderContent,
    AccessDenied,
    Ladda,
    VueUploadMultipleImage,
    UnitConversionForm
  },
  methods: {
    onSelectUnit(e) {
      this.select2FormUnitConversion.options = this.select2FormUnitConversion.allOptions.filter(v => v.id != this.form.unit_id);
      this.form.unit_conversions.forEach(item => {
        if (item.unit_id == this.form.unit_id) {
          item.unit_id = 0;
        }
      });
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    addUnit() {
      this.form.unit_conversions.push({
        unit_id: 0,
        conversion_factor: ''
      });
    },
    deleteUnit(index) {
      this.form.unit_conversions.splice(index, 1);
    },
    uploadImageSuccess(formData, index, fileList, fileSize) {
      let imgSize = fileSize / 1000000;
      let imgList = fileList;
      if (index >= this.image.maxImage || imgSize > this.image.maxSize) {
        imgList.splice(index, 1);
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
        return;
      }
      this.images = imgList;
      this.form.image = imgList[0].path;
    },
    beforeRemove(index, done, fileList, mediaId) {
      if (mediaId) this.form.remove_image = mediaId;
      done();
      this.images = fileList;
      this.form.image = '';
    },
    editImage(formData, index, fileList) {
      // "แก้รูป" = ทับรูปเดิม → ต้องส่ง remove_image ของเก่าไปด้วย (ดู products/OffcanvasForm.vue)
      const current = fileList[index];
      if (current?.id) this.form.remove_image = current.id;
      this.images = fileList;
      this.form.image = current.path;
    },
    limitExceeded(limit) {
      this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
    },
    async getCreateData() {
      await Inventories.getCreate().then(res => {
        this.select2FormBranch.options = res.data.data.branches.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.select2FormUnit.options = res.data.data.units.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.select2FormUnitConversion.allOptions = [...[{
          id: 0,
          text: this.$t('Select')+'...'
        }], ...res.data.data.unit_conversions.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        })];
        this.select2FormUnitConversion.options = this.select2FormUnitConversion.allOptions.filter(v => v.id != this.form.unit_id);
        this.select2FormCategory.options = res.data.data.categories.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.select2FormStorage.options = res.data.data.storage_conditions.map(v => {
          return {
            id: v,
            text: this.$t(v)
          }
        });
        this.select2FormType.options = res.data.data.types.map(v => {
          return {
            id: v.value,
            text: this.$t(v.text)
          }
        });
        this.select2FormTaxStatus.options = res.data.data.tax_status.map(v => {
          return {
            id: v.value,
            text: this.$t(v.text)
          }
        });
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    async getUpdateData() {
      await Inventories.getUpdate(this.inventoryId).then(res => {
        this.select2FormUnit.options = res.data.filter.units.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.select2FormCategory.options = res.data.filter.categories.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.select2FormStorage.options = res.data.filter.storage_conditions.map(v => {
          return {
            id: v,
            text: this.$t(v)
          }
        });
        this.select2FormTaxStatus.options = res.data.filter.tax_status.map(v => {
          return {
            id: v.value,
            text: this.$t(v.text)
          }
        });
        this.select2FormType.options = res.data.filter.types.map(v => {
          return {
            id: v.value,
            text: this.$t(v.text)
          }
        });
        this.form.unit_id = res.data.data.unit_id;
        this.select2FormUnitConversion.allOptions = [...[{
          id: 0,
          text: this.$t('Select')+'...'
        }], ...res.data.filter.unit_conversions.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        })];
        this.select2FormUnitConversion.options = this.select2FormUnitConversion.allOptions.filter(v => v.id != this.form.unit_id);
        this.form.name = res.data.data.name;
        this.form.code = res.data.data.code;
        this.form.type = res.data.data.type;
        this.form.tax_status = res.data.data.tax_status;
        this.form.unit_conversions = res.data.data.unit_conversions.map(v => {
          return {
            id: v.id,
            unit_id: v.unit_id,
            conversion_factor: v.conversion_factor,
            type: 'edit'
          }
        });
        setTimeout(() => {
          this.form.quantity = res.data.data.quantity;
          this.form.cost = res.data.data.cost;
          this.form.cost_manual = res.data.data.cost_manual ?? '';
        }, 1);
        this.images = res.data.data.images.map((v, k) => {
          return {
            id: v.id,
            default: 1,
            highlight: k == 0? 1: 0,
            name: v.file_name,
            path: v.image_url,
            type: 'old'
          }
        });
        this.form.storage_condition = res.data.data.storage_condition;
        this.form.inventory_category_id = res.data.data.inventory_category_id;

        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    setParamsBeforeSendCreate() {
      let params = _.clone(this.form);
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    setParamsBeforeSendUpdate() {
      let params = _.clone(this.form);
      delete params.quantity;
      delete params.code;
      delete params.cost;
      delete params.initial_stock_add;
      delete params.initial_stock_branch_id;
      delete params.initial_stock_quantity;
      delete params.initial_stock_cost;
      delete params.initial_stock_received_date;
      delete params.initial_stock_expiry_date;
      // ส่ง unit_conversions ทั้งหมด (เดิม+ใหม่) ให้ API sync — แก้/ลบของเดิมได้
      const costManual = params.cost_manual;
      delete params.cost_manual;
      $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
      params.cost_manual = (costManual === '' || costManual === null || costManual === undefined) ? null : costManual;
      return params;
    },
    async handleCreate() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      if (this.form.initial_stock_add) {
        this.form.quantity = this.form.initial_stock_quantity;
      } else {
        delete this.form.initial_stock_branch_id;
        delete this.form.initial_stock_quantity;
        delete this.form.initial_stock_cost;
        delete this.form.initial_stock_received_date;
        delete this.form.initial_stock_expiry_date;
      }
      await Inventories.create(this.form).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Save Inventory Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.errors) {
          this.oldParams = _.clone(this.form);
          this.errors = err?.response?.data?.errors;
        }
        const detail = apiErrorText(err, (key) => this.$t(key));
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t('Save Inventory Failed!') + (detail ? "\n" + detail : ''));
        this.loadingSave = false;
      });
    },
    async handleUpdate() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }

      await Inventories.update(this.inventoryId, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Inventory Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.errors) {
          this.oldParams = _.clone(this.form);
          this.errors = err?.response?.data?.errors;
        }
        const detail = apiErrorText(err, (key) => this.$t(key));
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t('Update Inventory Failed!') + (detail ? "\n" + detail : ''));
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        if (this.type === 'CREATE') await this.getCreateData();
        if (this.type === 'EDIT') await this.getUpdateData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.form.open = false;
    });
  },
  computed: {
    maxUploadImg: function() {
      return this.$t('You can choose to upload a maximum of') + ' ' + this.image.maxImage + ' ' + this.$t('imaes. The size is not over') + ' ' + this.image.maxSize + ' ' + this.$t('MB.');
    },
    // calculateQuantity: function() {
    //   return this.form.lots.reduce((accumulator, currentValue) => {
    //     return accumulator + currentValue.remaining_quantity;
    //   }, 0);
    // },
    // calculateCost: function() {
    //   const totalCost = this.form.lots.reduce((sum, item) => {
    //     return sum + (item.remaining_quantity * item.cost);
    //   }, 0);

    //   const totalQuantity = this.form.lots.reduce((sum, item) => {
    //     return sum + item.remaining_quantity;
    //   }, 0);

    //   if (totalQuantity === 0) {
    //     return 0;
    //   }

    //   return this.formatDigit(totalCost / totalQuantity);
    // },
    unitName: function() {
      return this.select2FormUnit.options.find(unit => unit.id == this.form.unit_id).text;
    },
  },
  watch: {
    // 'form.lots': {
    //   handler() {
    //     this.form.quantity = this.calculateQuantity;
    //     this.form.cost = this.calculateCost;
    //   },
    //   deep: true,
    //   immediate: true
    // }
  }
}
</script>
